import React from "react";
import { 
  TableRow, 
  TableCell,   
  Button, 
} from "@mui/material";  
import CustomCheckbox from "../CustomCheckbox";

const cellStyle = {
  padding: '10px 16px',
}; 

const BillingTableRow = ({ row, isSelected, onSelectToggle, }) => {
  return (
    <TableRow sx={{
      '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
      backgroundColor: '#fff',
      borderRadius: '10px',
      transition: 'box-shadow 0.3s ease',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        {row.id}
      </TableCell>

    
 
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
       {row.dueDate} 
      </TableCell>
  



 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.description}
      </TableCell>
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
         <Button
  sx={{
    background: row.status === "Paid" ? "#00C234" : "#F39C12",   
    color: row.status === "Paid" ? "#fff" : "#fff",         
    border: row.status === "Paid" ? "1px solid #00C234" : "1px solid #F39C12",
    fontSize: "13px",
    textTransform: "capitalize",
    borderRadius: "6px",
    px: 3,
  }}
>
  {row.status}
</Button>

      </TableCell>
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.seats}
      </TableCell>
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center', color:'#1760EC', }}>
        {row.invoiceTotal}
      </TableCell>
     
    </TableRow>
  );
};

export default BillingTableRow;
